module.exports = __webpack_public_path__ + "e108de2074fdd6823aabf5128565602f.glb";